
export type QueryMetricsGroupBy = typeof QueryMetricsGroupBy[keyof typeof QueryMetricsGroupBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QueryMetricsGroupBy = {
  HOUR: 'HOUR',
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
} as const;
